"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRowActions = useRowActions;
var react_1 = require("react");
var react_router_dom_1 = require("react-router-dom");
function useRowActions() {
    var navigate = (0, react_router_dom_1.useNavigate)();
    var rowActions = (0, react_1.useCallback)(function (row) { return []; }, [navigate]);
    return (0, react_1.useMemo)(function () { return ({
        rowActions: rowActions,
    }); }, [rowActions]);
}
